<template>
	<div id="app">
		<div class="map-area-container" :class="{'map-search-visible': searchVisible}">
			<Map project="aecd63b3ebb6420b8d5129748a6f6bc3" @poiClicked="onPOIClick" @onTouch="onClick" @loaded="mapLoaded" ref="map"/>
			
			<MapFloors/>
			<div class="header">
				<FlagsMenu />
				<div class="header-content">
					<BuildingLogo class="hide-landscape" />
					<div class="clock-container">
						<div class="clock hide-mobile">
							<ClockComponent format="HH:mm" />
						</div>
					</div>
				</div>
				<YAH class="hide-portrait tab-button" />
			</div>
			<Search @clicked="onSearchPOIClick" @close="onSearchClose"/>
		</div>
		<div class="menus">
			<div class="menus-top">
				<div class="col col-building-logo hide-portrait">
					<BuildingLogo />
				</div>
				<div class="col col-tabs">
					<YAH class="hide-landscape tab-button hide-mobile"/>
					<TabButtons @switchTab="switchMainTab"/>
				</div>
				<div class="col" v-show="!mobile">
					<ShortcutsMenu @toggleQR="toggleQR()" />
				</div>
			</div>
			<div class="menus-bottom" :class="[{'active': menuActive}]">
				<div class="col col-tabs-container tabs-container">
					<Tabs ref="tabs" :activeTab="currentTab" @tabChanged="tabChanged">
						<Tab name="az">
							<AZMenu @clicked="onPOIClick"/>
						</Tab>
						<Tab name="az2">
							<AZMenu @clicked="onPOIClick"/>
						</Tab>
						<Tab name="groups">
							<GroupsMenu @clicked="onGroupMenuClick"/>
						</Tab>
						<Tab name="group-pois">
							<GroupPOIsMenu @clicked="onPOIClick" @back="toGroups"/>
						</Tab>
						<Tab name="poi-info" class="hide-portrait">
							<POI @showPath="showPath" />
						</Tab>
					</Tabs>
				</div>
				<div class="col col-poi hide-landscape hide-mobile">
					<POI ref="poiInfo" @showPath="showPath"/>
					<div data-translation-element="no-menu" class="no-poi-info hide-landscape">Choose from the menu</div>
				</div>
			</div>
		</div>
		<QRBanner v-show="qrScreen" @close="toggleQR()" url=""></QRBanner>
		<div id="screensaver" class="banners-screensaver" v-show="screensaver" @click="hideBanner()">
			<Banner template="default" container="screensaver" class="hide-portrait" @clicked="onBannerClick" @hasbanners="hasBanners"></Banner>
			<Banner template="default" container="screensaver-portrait" class="hide-landscape" @clicked="onBannerClick" @hasbanners="hasBanners"></Banner>
		</div>
	</div>
</template>

<script>
/* global wayfinder */

import Map from './components/Map.vue'
import MapFloors from './components/MapFloors.vue'
import AZMenu from './components/AZMenu.vue'
import GroupsMenu from './components/GroupsMenu.vue'
import FlagsMenu from './components/FlagsMenu.vue'
import ShortcutsMenu from './components/ShortcutsMenu.vue'
import BuildingLogo from './components/BuildingLogo.vue'
import YAH from './components/YAH.vue'
import TabButtons from './components/TabButtons.vue'
import Tabs from './components/Tabs.vue'
import Tab from './components/Tab.vue'
import POI from './components/POI.vue'
import GroupPOIsMenu from './components/GroupPOIsMenu.vue'
import Search from './components/Search.vue'

import {ClockComponent} from 'vue-clock'
import { mapState } from 'vuex';

import Banner from './plugins/Banner.vue'
import QRBanner from './plugins/QRBanner.vue'

export default {
	name: 'app',
	components: {
		Map,
		MapFloors,
		AZMenu,
		GroupsMenu,
		GroupPOIsMenu,
		FlagsMenu,
		ShortcutsMenu,
		BuildingLogo,
		YAH,
		ClockComponent,
		TabButtons,
		POI,
		Tabs,
		Tab,
		Search,
		Banner,
		QRBanner
	},
	data () {
		return {
			lastClick: false,
			landscape: false,
			screensaver: true,
			hasScreensaver: false,
			menuActive: true,
			qrScreen: false
		}
	},
	mounted () {
		this.resize();

		window.onresize = () => {
			this.resize();
		}
	},
	computed: {//yahLogo
		...mapState(['currentTab', 'searchVisible', 'maxInActivity', 'mobile']),
	},
	methods: {
		onClick () {
			clearTimeout(this.lastClick);
			this.$refs['map'].run();
			
			this.lastClick = setTimeout(() => { // Start screensaver
				if(!this.mobile) {
					this.$refs.map.reset();
					this.reset();
				}
			}, this.maxInActivity * 1000);
			return false;
		},
		onGroupMenuClick (group) {
			this.$store.dispatch('SET_CURRENT_GROUP', group);
			this.$store.dispatch('SET_CURRENT_TAB', 'group-pois');
		},
		onPOIClick (poi, map) {
			this.$store.dispatch('SET_CURRENT_POI', poi);
			if (this.landscape || this.mobile) {
				this.$store.dispatch('SET_CURRENT_TAB', 'poi-info');
				if (this.mobile) {
					this.menuActive = true;
				}
			}
			if (!map) {
				wayfinder.statistics.onClick(poi.id, "menu");
			}
		},
		onSearchPOIClick (poi) {
			if (poi) {
				this.onPOIClick(poi);
				wayfinder.showPath(poi.getNode(), poi)
				wayfinder.clearHighlights();
				wayfinder.setHighlights([poi]);
			}
		},

		showPath (poi) {
			if (this.mobile) {
				this.menuActive = false;
			}
			wayfinder.showPath(poi.getNode(), poi)
			wayfinder.clearHighlights();
			wayfinder.setHighlights([poi]);
		},
		onSearchClose () {
			if (this.landscape) {
				//this.$store.dispatch('SET_CURRENT_TAB', 'poi-info');
			}
		},
		reset () {
			this.$store.dispatch('SET_CURRENT_TAB', 'groups');
			this.$store.dispatch('SHOW_SEARCH', false);
			this.$store.dispatch('SET_RESET');
			this.menuActive = false;
			this.screensaver = this.hasScreensaver && !this.mobile;
			this.qrScreen = false;
			this.$refs['map'].pause();
		},
		resize () {
			let _l = window.matchMedia("(orientation: landscape)");
			let _pm = window.matchMedia("(max-height: 1024px) and (orientation: portrait)");
			let _lm = window.matchMedia("(max-width: 1024px) and (orientation: landscape)");
			this.landscape = _l ? _l.matches : false;
			let mobile = (_pm ? _pm.matches : false) || (_lm ? _lm.matches : false);
			this.$store.dispatch('SET_LANDSCAPE', this.landscape);
			this.$store.dispatch('SET_MOBILE', mobile);
		},
		doSomething () {},
		switchMainTab (tab) {
			if (tab !== 'search') {
				if (!(tab === 'poi-info' && !this.landsape)) {
					this.$store.dispatch('SET_CURRENT_TAB', tab);
				}

				if (this.mobile) {
					this.$store.dispatch('SHOW_SEARCH', false);
				}
			}
			else {
				this.$store.dispatch('SHOW_SEARCH', !this.searchVisible);
			}

			if (tab == 'map' || tab == 'az2') {
				this.menuActive = false;
				if ( this.landscape) { // leave in landscape
					this.$store.dispatch('SET_CURRENT_TAB', 'az2');
				}	 
			}
		},
		onBannerClick (/*frame, container*/) {
			this.screensaver = false;
			this.$refs['map'].run();
		},
		toGroups () {
			this.$store.dispatch('SET_CURRENT_TAB', 'groups');
		},
		hideBanner () {
			this.screensaver = false;
		},
		mapLoaded () {
			this.screensaver = false;
			this.$refs['map'].run();
			// popup az menu as default
			if (this.mobile) {
				this.$store.dispatch('SET_CURRENT_TAB', 'groups');
			}
		},
		hasBanners (has) {
			console.log('hasbanners', has);
			this.hasScreensaver = has;
		},
		tabChanged () {
			this.menuActive = true;
		},
		toggleQR () {
			this.qrScreen = !this.qrScreen;
		}
	}
};
</script>

<style lang="less">
@import 'theme/variables';

* {
	box-sizing: border-box;
}

html, body {
	margin: 0;
	height: 100%;
	width: 100%;
	position: relative;
	box-sizing: border-box;
	font-size: @font-size;
	font-family: Arial;
	color: @font-color;
	user-select: none;
	font-family: 'Ubuntu', sans-serif;
}

body {
	background-color: @backgroundColor;
	box-sizing: border-box;
}

button {
	font-family: inherit;
}

#app {
	height: 100%;
	overflow: hidden;
}

.map-area-container {
	height: 100%;
	width: @map-width;
	position: relative;

	.map-floors-container {
		position: absolute;
		right: 0;
		top: 15rem;
	}
}

.menus {
	width: 100%;

	.menus-top {
		display: flex;
	}

	.col-building-logo {
		.building-logo {
			background-size: auto 60%;
		}
	}
}

.main-menu {
	flex-grow: 1;
}

.submenu-container {
	display: flex;
	padding: 2rem;
	justify-content: space-between;
	height: 5rem;
}

.list {
	user-select: none;
	margin: 0;
	padding: 0;

	.list-item {
		list-style: none;
		padding: 0.3rem;
		border-bottom: 1px solid @menu-item-border-color;
		padding: 1.2rem 2rem 1.2rem 2.2rem;
		font-size: 1.3rem;
		user-select: none;
	}

	.list-item:active, .list-item.active {
		.list-item-gradient();
	}
}

.header {
	position: absolute;
	top: 0;
	width: 100%;
	height: @header-height;
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;

	.building-logo {
		height: 100%;
		width: 50%;
		margin: auto;
		background-size: auto 60%;
	}

	.header-content {
		background-color: @main-background;
		height: 100%;
		.default-drop-shadow();
		border-radius: 0 0 @corner-radius-large @corner-radius-small;
		flex-grow: 1;
		display: flex;
		margin-left: 0.5rem;

		.clock-container {
			width: 10rem;
			padding-right: 1.7rem;
			padding-top: 1.5rem;
			text-align: right;

			.clock {
				display: inline-block;
				font-size: 2.2rem;
				border: 1px solid @menu-item-border-color;
				border-radius: 2rem;
				padding: 0.5rem 1.5rem;
				margin-left: auto;
				font-weight: 600;
				background-color: rgba(255, 255, 255, 0.7);

				span {
					color: @highlight-color !important;
				}
			}
		}
	}

	.languages-container {
		background-color: @main-background;
		border-radius: 0 0 @corner-radius-small @corner-radius-large;
		.default-drop-shadow();
		height: 100%;
		width: 9rem;
	}
}

.tabs-container {
	height: 100%;
	
	.default-drop-shadow();
	flex-shrink: 1;
	border-radius: @corner-radius-small;

	.tabs {
		width: 100%;
		height: 100%;
		position: relative;
	}
}

.tab-button {
	width: calc(33% - @menu-margin);
	height: @menus-col-height;
	background-size: auto @menus-col-height * 0.3;
	background-position: 50% 1.6rem;
	background-repeat: no-repeat;
	background-color: @main-background;
	padding-top: @menus-col-height * 0.7;
	padding-right: 0.5rem;
	padding-left: 0.5rem;
	text-align: center;
	text-transform: uppercase;
	margin-bottom: @menu-margin;
	font-size: 1.05rem;
	text-overflow: ellipsis;
	overflow: hidden;
	border-radius: @corner-radius-small;
	font-weight: 600;
	line-height: 2rem;

	.default-drop-shadow();

	&:last-child {
		margin-right: 0;
	}

	&:active {
		background-color: @tertiary-color;
	}
}

.col-poi {
	.default-drop-shadow();
	border-radius: @corner-radius-small;
}

.button {
	height: 3rem;

	i {
		height: 3rem;
		width: 3rem;
		float: left;
		background-repeat: no-repeat;
		background-position: 50% 0.6rem;
		background-size: auto 50%;
		margin-left: -1.5rem;
	}
}

.menus-bottom {
	margin-top: 0.3rem;
	bottom: 0;
	flex-shrink: 1;
    overflow: hidden;

	.no-poi-info {
		margin: auto;
		text-align: center;
		margin-top: 60%;
		font-size: 140%;
		color: #a8a8b0;

		&:before {
			content: '';
			background-repeat: no-repeat;
			background-size: contain;
			background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8' standalone='no'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 192 512'%3E%3Cpath d='M4.2 247.5L151 99.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17L69.3 256l118.5 119.7c4.7 4.7 4.7 12.3 0 17L168 412.5c-4.7 4.7-12.3 4.7-17 0L4.2 264.5c-4.7-4.7-4.7-12.3 0-17z' id='path2' style='fill:%23a8a8b0' /%3E%3C/svg%3E%0A");
			width: 2rem;
			height: 4rem;
			display: block;
			margin: auto;
			margin-top: -5rem;
		}
	}
}

.grab-bing {
  cursor : -webkit-grab;
  cursor : -moz-grab;
  cursor : -o-grab;
  cursor : grab;
}
 
 
.grab-bing:active {
  cursor : -webkit-grabbing;
  cursor : -moz-grabbing;
  cursor : -o-grabbing;
  cursor : grabbing;
}

.search {
	top: 50%;
	bottom: 50%;
	right: 0;
	left: 0;
	opacity: 0;
	position: absolute;
	z-index: 100;
	overflow: hidden;
	transition: opacity 0.2s ease-in;
	transition: top,bottom 0.2s ease-in;
	transition: bottom 0.2s ease-out;

	&.search-visible {
		opacity: 1;
		top: 0;
		bottom: 0;
	}
}

@media @landscape {
	#app {
		display: flex;
		flex-direction: row;
	}

	.map-area-container {
		&.map-search-visible {
			.yah-logo {
				opacity: 0;
			}
		}
	}

	.header {
		.header-content {
			background-color: transparent;
			box-shadow: none;
			padding-left: 1rem;

			.clock-container {
				padding-top: 1.7rem;
			}
		}

		.yah-logo {
			width: 10rem !important;
			background-color: @main-background;
			margin-right: 0.5rem;
			padding-top: @menus-col-height-landscape * 0.6;
		}

		.languages-container {
			border-radius: 0 @corner-radius-small @corner-radius-large @corner-radius-small;
		}
	}
	
	.menus {
		height: 100%;
		width: 34rem;
		overflow: hidden;
		padding-left: 2px;

		display: flex;
		flex-direction: column;
		
		.menus-top {
			display: flex;
			flex-direction: column;
		}

		.col-building-logo { 
			margin-bottom: @menu-margin;
		}

		.building-logo {
			height: @menus-col-height-landscape;
			border-radius: @corner-radius-small;
			.default-drop-shadow();
		}

		.col-tabs {
			order: 1;
		}

		.col-tabs-container {
			order: 1;
			flex-grow: 1;
		}

		.menus-bottom {
			flex-grow: 1;
			display: flex;
			flex-basis: 2rem;
			width: 100%;
			height: 100%;
		}
	}

	.hide-landscape {
		display: none;
	}

	.tab-button {
		height: @menus-col-height-landscape;
		padding-top: @menus-col-height-landscape * 0.65;
		margin-bottom: @menu-margin * 0.5;
	}
}

@media @portrait {
	.map-area-container {
		width: 100%;
		height: @map-height;

		.map-floors-container {
			bottom: 0.5rem;
			top: auto;
			margin: auto;
			right: 0;
			width: 100%;

			.map-floors {
				display: flex;
				flex-direction: row-reverse;
				justify-content: center;
				align-items: flex-end;

				.button-floor {
					flex-shrink: 1;
					margin-left: initial;
				}
			}
		}
	}

	.hide-portrait {
		display: none;
	}

	&.map-search-visible {
		.map-floors-container {
			opacity: 0;
		}
	}
	
	.menus {
		height: 100% - @map-height;
		position: relative;
		padding: 1rem;

		.menus-top {
			height: @menus-top-portrait;
			user-select: none;
			columns: 2;
			column-gap: 0rem;

			.col:nth-child(even) {
				margin-right: 1rem;
			}

			.yah-logo {
				width: 100% !important;
				padding-top: @menus-col-height * 0.65w;
			}
		}

		.menus-bottom {
			display: flex;
			position: absolute;
			top: @menus-top-portrait + 1rem;
			bottom: 1rem;
			left: 1rem;
			right: 1rem;

			.col-tabs-container {
				margin-right: 1rem;
			}
		}

		.col {
			width: 50%;
			margin-bottom: -1rem;
		}
	}
	
	.tab-button {
		background-size: auto @menus-col-height * 0.4;
		background-position: 50% @menus-col-height * 0.26;
		padding-top: @menus-col-height * 0.72;
		font-size: 1.15rem;

	}
}

.banners-screensaver {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	overflow: hidden;
	z-index: 99;
	background-image: url('assets/logo.png');
	background-size: 20%;
	background-position: 50% 50%;
	background-repeat: no-repeat;
	background-color: white;
}

@media (min-height: 1280px) and (max-height: 2560px) and (orientation: landscape) {
	html {
		font-size: 16px !important;
	}
}

@media (min-width: 1024px) and (max-width: 1280px) and (orientation: landscape) {
	html {
		font-size: 12px !important;
	}
}

@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
	html {
		font-size: 10px !important;
	}

	.map-floors-container {
			bottom: 15%;
			top: 40% !important;
			right: 0;
			width: 6rem;
	}
}


// Mobile
@media (max-height: 1024px) and (orientation: portrait) {
	html {
		font-size: 8px !important;
	}

	.hide-mobile {
		display: none !important;
	}

	#app {
		display: flex;
		flex-direction: column;
	}

	.map-area-container {
		height: calc(100% - @menus-col-height);

		.map-shortcuts {
			justify-content: flex-end !important;
			.tab-button {
				width: @map-shortcuts-mobile-width !important;
				height: @map-shortcuts-mobile-width;
				padding-top: @map-shortcuts-mobile-width * 0.7;
				font-size: 1rem;
				background-size: auto @map-shortcuts-mobile-width * 0.4;
				background-position: 50% @map-shortcuts-mobile-width * 0.25;
				margin-bottom: 0.5rem;
			}
		}

		.map-floors-container {
			bottom: 15%;
			top: 15%;
			right: 0;
			width: 6rem;

			.map-floors {
				height: 100%;
				align-items: center;
				flex-direction: column;
				justify-content: flex-end !important;
			}
		}
	}

	.list .list-item {
		font-size: 2rem;
		padding-left: 3rem;


		&.list-header::before {
			width: 3rem;
			height: 3rem;
			margin-left: -2rem;
		}
	}

	.menus {
		height: @menus-col-height;
		columns: unset;
		position: unset;
		padding: 0;

		

		.col {
			width: 100%;
		}

		.col-tabs {
			width: 100%;
			flex-grow: 1;
			display: flex;
			height: 100%;
		}

		.menus-top {
			columns: unset;
			.drop-shadow();

			.tab-buttons {
				width: 100%;
				justify-content: center;

				.tab-button {
					width: 20%;
					box-shadow: none;
				}
			}
		}

		.menus-bottom {
			display: none;
			position: absolute;
			background-color: @main-background;

			&.active {
				display: block;
				top: @header-height + 0.5rem;
				bottom: @menus-col-height + 1.5rem
			}
		}
	}
}

@media (min-height: 1024px) and (max-height: 1280px) and (orientation: portrait) {
	html {
		font-size: 12px !important;
	}
}

</style>
